// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2718%27 height=%2718%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23FFFFFF%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Crect x=%273%27 y=%274%27 width=%2718%27 height=%2718%27 rx=%272%27 ry=%272%27/%3E%3Cline x1=%2716%27 y1=%272%27 x2=%2716%27 y2=%276%27/%3E%3Cline x1=%278%27 y1=%272%27 x2=%278%27 y2=%276%27/%3E%3Cline x1=%273%27 y1=%2710%27 x2=%2721%27 y2=%2710%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================================
   ORDERS HISTORY PAGE STYLES
   Table grid on desktop, cards on mobile
   Light and dark modes
   ================================== */

:root {
  /* Light Mode */
  --light-bg-primary: #f4f5f7;
  --light-bg-secondary: #ffffff;
  --light-bg-tertiary: #eef0f4;
  --light-text-primary: #1c1f26;
  --light-text-secondary: #636b7a;
  --light-border: #e2e4ea;
  --light-shadow: rgba(23, 26, 33, 0.06);

  /* Dark Mode */
  --dark-bg-primary: #14161c;
  --dark-bg-secondary: #1d2027;
  --dark-bg-tertiary: #262a33;
  --dark-text-primary: #eef0f4;
  --dark-text-secondary: #ffffff;
  --dark-border: #323644;
  --dark-shadow: rgba(0, 0, 0, 0.35);

  /* Accent Colors - a single cohesive indigo/teal pairing instead of the old purple/cyan clash */
  --accent-primary: green;
  --accent-primary-soft: #eef1fd;
  --accent-primary-soft-dark: rgba(79, 70, 229, 0.18);
  --accent-secondary: #0d9488;
  --accent-danger: #dc2626;
  --accent-success: #059669;
  --accent-warning: #d97706;

  --transition-fast: 0.15s ease-in-out;
  --transition-smooth: 0.25s ease-in-out;

  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 14px;
}

/* ==================================
   BASE
   ================================== */

.orders-history-container {
  direction: rtl;
  text-align: right;
  padding: 2rem 1.5rem;
  min-height: 100vh;
  transition: background-color var(--transition-smooth), color var(--transition-smooth);
}

.orders-history-container.light-mode {
  background-color: var(--light-bg-primary);
  color: var(--light-text-primary);
}

.orders-history-container.dark-mode {
  background-color: var(--dark-bg-primary);
  color: var(--dark-text-primary);
}

/* ==================================
   HEADER
   ================================== */

.orders-header {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1.75rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid var(--light-border);
}

.orders-history-container.light-mode .orders-header {
  border-bottom-color: var(--light-border);
}

.orders-history-container.dark-mode .orders-header {
  border-bottom-color: var(--dark-border);
}

.orders-title {
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0;
  flex-grow: 1;
  text-align: center;
  letter-spacing: -0.3px;
}
.orders-history-container.dark-mode .orders-title {
  color: var(--dark-text-primary);
}

/* ==================================
   FILTERS SECTION
   ================================== */

.filters-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.25rem;
  margin-bottom: 1.75rem;
  padding: 1.25rem 1.5rem;
  border-radius: var(--radius-lg);
  align-items: end;
  transition: background-color var(--transition-smooth);
}

.orders-history-container.light-mode .filters-section {
  background-color: var(--light-bg-secondary);
  border: 1px solid var(--light-border);
}

.orders-history-container.dark-mode .filters-section {
  background-color: var(--dark-bg-secondary);
  border: 1px solid var(--dark-border);
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  max-width: fit-content;
}

.filter-group label {
  font-size: 1.2rem;
  font-weight: 600;
}

.orders-history-container.light-mode .filter-group label {
  color: var(--light-text-secondary);
}

.orders-history-container.dark-mode .filter-group label {
  color: var(--dark-text-secondary);
}

.date-input {
  padding: 0.6rem 0.9rem;
  border-radius: var(--radius-md);
  font-size: 1.2rem;
  transition: all var(--transition-fast);
  cursor: pointer;
}

.orders-history-container.light-mode .date-input {
  background-color: var(--light-bg-primary);
  color: var(--light-text-primary);
  border: 1px solid var(--light-border);
}

.orders-history-container.light-mode .date-input:hover,
.orders-history-container.light-mode .date-input:focus {
  border-color: var(--accent-primary);
  outline: none;
  background-color: var(--light-bg-secondary);
}

.orders-history-container.dark-mode .date-input {
  background-color: var(--dark-bg-primary);
  color: var(--dark-text-primary);
  border: 1px solid var(--dark-border);
}

.orders-history-container.dark-mode .date-input:hover,
.orders-history-container.dark-mode .date-input:focus {
  border-color: var(--accent-primary);
  outline: none;
  background-color: var(--dark-bg-secondary);
}

/* Make native date-picker icons visible on dark backgrounds */
.orders-history-container.dark-mode .date-input::-webkit-calendar-picker-indicator {
  filter: invert(1) brightness(2) saturate(0.9);
}

/* Firefox calendar indicator */
.orders-history-container.dark-mode .date-input::-moz-calendar-picker-indicator {
  filter: invert(1) brightness(2) saturate(0.9);
}

/* Fallback: for browsers where indicators don't respond to filter, hide
   the native icon and provide a white SVG as a background image aligned
   to the right. This keeps aesthetics consistent. */
.orders-history-container.dark-mode .date-input {
  background-repeat: no-repeat;
  background-position: right 0.6rem center;
  padding-right: 2.6rem; /* leave room for the icon */
}
.orders-history-container.dark-mode .date-input.hide-native-icon::-webkit-calendar-picker-indicator {
  display: none;
}
.orders-history-container.dark-mode .date-input.custom-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 0.9rem;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-user-select: none;
          user-select: none;
  font-weight: 500;
  font-size: 1.2rem;
}

.orders-history-container.light-mode .checkbox-label {
  background-color: var(--light-bg-primary);
  border: 1px solid var(--light-border);
}

.orders-history-container.light-mode .checkbox-label:hover {
  background-color: var(--accent-primary-soft);
  border-color: var(--accent-primary);
}

.orders-history-container.dark-mode .checkbox-label {
  background-color: var(--dark-bg-primary);
  border: 1px solid var(--dark-border);
}

.orders-history-container.dark-mode .checkbox-label:hover {
  background-color: var(--accent-primary-soft-dark);
  border-color: var(--accent-primary);
}

.checkbox-input,
.card-checkbox {
  width: 17px;
  height: 17px;
  cursor: pointer;
  accent-color: var(--accent-primary);
}

/* ==================================
   PRINT BUTTON
   ================================== */

.print-button {
  padding: 0.7rem 1.4rem;
  border: none;
  border-radius: var(--radius-md);
  font-size: 1.2rem;
  font-weight: 600;
  background-color: var(--accent-primary);
  color: white;
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
  align-self: flex-end;
  max-width: fit-content;
}


.print-button:active:not(:disabled) {
  transform: translateY(1px);
}

.print-button.disabled,
.print-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ==================================
   EMPTY STATE / NO RESULTS
   ================================== */

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  border-radius: var(--radius-lg);
  margin-top: 2rem;
}

.orders-history-container.light-mode .empty-state {
  background-color: var(--light-bg-secondary);
  border: 1px solid var(--light-border);
}

.orders-history-container.dark-mode .empty-state {
  background-color: var(--dark-bg-secondary);
  border: 1px solid var(--dark-border);
}

.empty-icon {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  opacity: 0.6;
}

.empty-order-message {
  font-size: 1.1rem;
  margin: 0;
  font-weight: 500;
}

.orders-history-container.light-mode .empty-order-message {
  color: var(--light-text-secondary);
}

.orders-history-container.dark-mode .empty-order-message {
  color: var(--dark-text-secondary);
}

.no-results {
  text-align: center;
  padding: 3rem 2rem;
  font-size: 1rem;
}

.orders-history-container.light-mode .no-results {
  color: var(--light-text-secondary);
}

.orders-history-container.dark-mode .no-results {
  color: var(--dark-text-secondary);
}

/* ==================================
   VIEW SWITCH (table on desktop, cards on mobile)
   ================================== */

.desktop-view {
  display: block;
}

.mobile-view {
  display: none;
}

/* ==================================
   DESKTOP TABLE
   ================================== */

.orders-table-wrapper {
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.orders-history-container.light-mode .orders-table-wrapper {
  border: 1px solid var(--light-border);
  background-color: var(--light-bg-secondary);
}

.orders-history-container.dark-mode .orders-table-wrapper {
  border: 1px solid var(--dark-border);
  background-color: var(--dark-bg-secondary);
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.92rem;
}

.orders-table thead th {
  text-align: right;
  padding: 0.85rem 1rem;
  font-weight: 600;
  font-size: 1.2rem;
}

.orders-history-container.light-mode .orders-table thead th {
  color: var(--light-text-secondary);
  background-color: var(--light-bg-tertiary);
  border-bottom: 1px solid var(--light-border);
}

.orders-history-container.dark-mode .orders-table thead th {
  color: var(--dark-text-secondary);
  background-color: var(--dark-bg-tertiary);
  border-bottom: 1px solid var(--dark-border);
}

.orders-table th.col-check,
.orders-table td.col-check {
  width: 64px;
  text-align: center;
}

.orders-table td.items-cell {
  min-width: 260px;
}

.orders-table tbody tr {
  transition: background-color var(--transition-fast);
}

.orders-history-container.light-mode .orders-table tbody tr {
  border-bottom: 1px solid var(--light-border);
}

.orders-history-container.dark-mode .orders-table tbody tr {
  border-bottom: 1px solid var(--dark-border);
}

.orders-history-container.light-mode .orders-table tbody tr:hover {
  background-color: var(--light-bg-tertiary);
}

.orders-history-container.dark-mode .orders-table tbody tr:hover {
  background-color: var(--dark-bg-tertiary);
}

.orders-history-container.light-mode .orders-table tbody tr.row-selected {
  background-color: var(--accent-primary-soft);
}

.orders-history-container.dark-mode .orders-table tbody tr.row-selected {
  background-color: var(--accent-primary-soft-dark);
}

.orders-table td {
  padding: 0.85rem 1rem;
  vertical-align: middle;
}

.order-number-cell {
  font-weight: 700;
  color: var(--accent-primary);
}

/* ==================================
   SHARED: STATUS BADGE / VALUE HIGHLIGHT
   ================================== */

.value-highlight {
  color: var(--accent-success);
  font-weight: 700;
}

.status-badge {
  display: inline-block;
  padding: 0.3rem 0.7rem;
  border-radius: var(--radius-sm);
  font-size: 0.78rem;
  font-weight: 600;
}

.status-active {
  background-color: rgba(5, 150, 105, 0.12);
  color: var(--accent-success);
}

.status-pending {
  background-color: rgba(217, 119, 6, 0.12);
  color: var(--accent-warning);
}

.status-completed {
  background-color: rgba(37, 99, 235, 0.12);
  color: #2563eb;
}

.status-cancelled {
  background-color: rgba(220, 38, 38, 0.12);
  color: var(--accent-danger);
}

/* ==================================
   ITEMS: inline list inside the row (desktop table)
   and grid (mobile cards) — no expand/collapse needed
   ================================== */

.items-subtable {
  width: 100%;
  border-collapse: collapse;
}

.items-subtable tr:not(:last-child) td {
  border-bottom: 1px dashed transparent;
}

.orders-history-container.light-mode .items-subtable tr:not(:last-child) td {
  border-bottom-color: var(--light-border);
}

.orders-history-container.dark-mode .items-subtable tr:not(:last-child) td {
  border-bottom-color: var(--dark-border);
}

.items-subtable td {
  padding: 0.5rem 0.4rem;
  vertical-align: middle;
}

.items-subtable-name {
  text-align: right;
}

.items-subtable-qty {
  width: 50px;
  text-align: center;
}

.items-subtable-image {
  width: 56px;
  text-align: center;
}

.item-thumb {
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: var(--radius-sm);
  display: inline-block;
}

.item-thumb-placeholder {
  background-color: var(--light-bg-tertiary);
}

.orders-history-container.dark-mode .item-thumb-placeholder {
  background-color: var(--dark-bg-tertiary);
}

.order-items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.6rem;
  margin-top: 0.5rem;
}

.item-mini {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.6rem;
  border-radius: var(--radius-md);
  border-right: 3px solid var(--accent-secondary);
}

.orders-history-container.light-mode .item-mini {
  background-color: var(--light-bg-primary);
}

.orders-history-container.dark-mode .item-mini {
  background-color: var(--dark-bg-primary);
}

.item-qty-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  background-color: var(--accent-secondary);
  color: white;
  border-radius: 50%;
  font-size: 0.8rem;
  font-weight: 700;
  flex-shrink: 0;
}

.item-description {
  flex-grow: 1;
  min-width: 0;
}

.item-name {
  font-size: 0.88rem;
  font-weight: 600;
  word-break: break-word;
  line-height: 1.4;
}

.orders-history-container.light-mode .item-name {
  color: var(--light-text-primary);
}

.orders-history-container.dark-mode .item-name {
  color: var(--dark-text-primary);
}

.item-variant {
  font-size: 0.78rem;
  margin-top: 0.2rem;
  word-break: break-word;
}

.orders-history-container.light-mode .item-variant {
  color: var(--light-text-secondary);
}

.orders-history-container.dark-mode .item-variant {
  color: var(--dark-text-secondary);
}

/* ==================================
   MOBILE CARDS
   ================================== */

.orders-grid.mobile-view {
  grid-template-columns: 1fr;
  gap: 1rem;
}

.order-card-modern {
  border-radius: var(--radius-lg);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.2s ease-out;
}

.orders-history-container.light-mode .order-card-modern {
  background-color: var(--light-bg-secondary);
  border: 1px solid var(--light-border);
}

.orders-history-container.dark-mode .order-card-modern {
  background-color: var(--dark-bg-secondary);
  border: 1px solid var(--dark-border);
}

.order-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1rem;
}

.orders-history-container.light-mode .order-card-header {
  border-bottom: 1px solid var(--light-border);
  background-color: var(--light-bg-tertiary);
}

.orders-history-container.dark-mode .order-card-header {
  border-bottom: 1px solid var(--dark-border);
  background-color: var(--dark-bg-tertiary);
}

.selection-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-number {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--accent-primary);
  flex-grow: 1;
  text-align: center;
}

.order-card-body {
  padding: 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.order-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem 0;
  font-size: 0.92rem;
}

.order-info-row .label {
  font-weight: 600;
}

.orders-history-container.light-mode .order-info-row .label {
  color: var(--light-text-secondary);
}

.orders-history-container.dark-mode .order-info-row .label {
  color: var(--dark-text-secondary);
}

.order-info-row .value {
  font-weight: 500;
}

.orders-history-container.light-mode .order-info-row .value {
  color: var(--light-text-primary);
}

.orders-history-container.dark-mode .order-info-row .value {
  color: var(--dark-text-primary);
}

.divider {
  height: 1px;
  margin: 0.5rem 0;
}

.orders-history-container.light-mode .divider {
  background-color: var(--light-border);
}

.orders-history-container.dark-mode .divider {
  background-color: var(--dark-border);
}

.items-header {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--accent-secondary);
  padding-bottom: 0.4rem;
  border-bottom: 2px solid var(--accent-secondary);
}

@keyframes slideIn {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ==================================
   RESPONSIVE: swap table for cards under 768px
   ================================== */

@media (max-width: 768px) {
  .orders-history-container {
    padding: 1rem 0.75rem;
  }

  .orders-title {
    font-size: 1.3rem;
  }

  .filters-section {
    padding: 1rem;
    gap: 0.75rem;
    grid-template-columns: 1fr;
  }

  .print-button {
    align-self: stretch;
  }

  .desktop-view {
    display: none;
  }

  .mobile-view {
    display: grid;
  }
}

@media (max-width: 480px) {
  .orders-header {
    flex-direction: column;
    gap: 0.6rem;
  }

  .orders-title {
    width: 100%;
  }
}

/* Print media (browser print, kept as a fallback — the real export is the
   server-generated PDF from the Print button) */
@media print {
  .filters-section,
  .print-button,
  .orders-header {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/orders.css"],"names":[],"mappings":"AAAA;;;;uCAIuC;;AAEvC;EACE,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,sCAAsC;;EAEtC,cAAc;EACd,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;;EAElC,+FAA+F;EAC/F,uBAAuB;EACvB,8BAA8B;EAC9B,mDAAmD;EACnD,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;;EAEzB,oCAAoC;EACpC,sCAAsC;;EAEtC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;uCAEuC;;AAEvC;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,qFAAqF;AACvF;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;;uCAEuC;;AAEvC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;;AAEA;;uCAEuC;;AAEvC;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;;EAEE,mCAAmC;EACnC,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;;EAEE,mCAAmC;EACnC,aAAa;EACb,0CAA0C;AAC5C;;AAEA,8DAA8D;AAC9D;EACE,6CAA6C;AAC/C;;AAEA,+BAA+B;AAC/B;EACE,6CAA6C;AAC/C;;AAEA;;oDAEoD;AACpD;EACE,4BAA4B;EAC5B,wCAAwC;EACxC,qBAAqB,EAAE,4BAA4B;AACrD;AACA;EACE,aAAa;AACf;AACA;EACE,yDAAka;AACpa;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,iDAAiD;EACjD,mCAAmC;AACrC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mCAAmC;AACrC;;AAEA;;uCAEuC;;AAEvC;EACE,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;uCAEuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;uCAEuC;;AAEvC;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;uCAEuC;;AAEvC;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;uCAEuC;;AAEvC;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;;;uCAGuC;;AAEvC;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;uCAEuC;;AAEvC;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;;uCAEuC;;AAEvC;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;gDACgD;AAChD;EACE;;;IAGE,aAAa;EACf;AACF","sourcesContent":["/* ==================================\n   ORDERS HISTORY PAGE STYLES\n   Table grid on desktop, cards on mobile\n   Light and dark modes\n   ================================== */\n\n:root {\n  /* Light Mode */\n  --light-bg-primary: #f4f5f7;\n  --light-bg-secondary: #ffffff;\n  --light-bg-tertiary: #eef0f4;\n  --light-text-primary: #1c1f26;\n  --light-text-secondary: #636b7a;\n  --light-border: #e2e4ea;\n  --light-shadow: rgba(23, 26, 33, 0.06);\n\n  /* Dark Mode */\n  --dark-bg-primary: #14161c;\n  --dark-bg-secondary: #1d2027;\n  --dark-bg-tertiary: #262a33;\n  --dark-text-primary: #eef0f4;\n  --dark-text-secondary: #ffffff;\n  --dark-border: #323644;\n  --dark-shadow: rgba(0, 0, 0, 0.35);\n\n  /* Accent Colors - a single cohesive indigo/teal pairing instead of the old purple/cyan clash */\n  --accent-primary: green;\n  --accent-primary-soft: #eef1fd;\n  --accent-primary-soft-dark: rgba(79, 70, 229, 0.18);\n  --accent-secondary: #0d9488;\n  --accent-danger: #dc2626;\n  --accent-success: #059669;\n  --accent-warning: #d97706;\n\n  --transition-fast: 0.15s ease-in-out;\n  --transition-smooth: 0.25s ease-in-out;\n\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 14px;\n}\n\n/* ==================================\n   BASE\n   ================================== */\n\n.orders-history-container {\n  direction: rtl;\n  text-align: right;\n  padding: 2rem 1.5rem;\n  min-height: 100vh;\n  transition: background-color var(--transition-smooth), color var(--transition-smooth);\n}\n\n.orders-history-container.light-mode {\n  background-color: var(--light-bg-primary);\n  color: var(--light-text-primary);\n}\n\n.orders-history-container.dark-mode {\n  background-color: var(--dark-bg-primary);\n  color: var(--dark-text-primary);\n}\n\n/* ==================================\n   HEADER\n   ================================== */\n\n.orders-header {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  margin-bottom: 1.75rem;\n  padding-bottom: 1.25rem;\n  border-bottom: 1px solid var(--light-border);\n}\n\n.orders-history-container.light-mode .orders-header {\n  border-bottom-color: var(--light-border);\n}\n\n.orders-history-container.dark-mode .orders-header {\n  border-bottom-color: var(--dark-border);\n}\n\n.orders-title {\n  font-size: 1.6rem;\n  font-weight: 700;\n  margin: 0;\n  flex-grow: 1;\n  text-align: center;\n  letter-spacing: -0.3px;\n}\n.orders-history-container.dark-mode .orders-title {\n  color: var(--dark-text-primary);\n}\n\n/* ==================================\n   FILTERS SECTION\n   ================================== */\n\n.filters-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.25rem;\n  margin-bottom: 1.75rem;\n  padding: 1.25rem 1.5rem;\n  border-radius: var(--radius-lg);\n  align-items: end;\n  transition: background-color var(--transition-smooth);\n}\n\n.orders-history-container.light-mode .filters-section {\n  background-color: var(--light-bg-secondary);\n  border: 1px solid var(--light-border);\n}\n\n.orders-history-container.dark-mode .filters-section {\n  background-color: var(--dark-bg-secondary);\n  border: 1px solid var(--dark-border);\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  max-width: fit-content;\n}\n\n.filter-group label {\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.orders-history-container.light-mode .filter-group label {\n  color: var(--light-text-secondary);\n}\n\n.orders-history-container.dark-mode .filter-group label {\n  color: var(--dark-text-secondary);\n}\n\n.date-input {\n  padding: 0.6rem 0.9rem;\n  border-radius: var(--radius-md);\n  font-size: 1.2rem;\n  transition: all var(--transition-fast);\n  cursor: pointer;\n}\n\n.orders-history-container.light-mode .date-input {\n  background-color: var(--light-bg-primary);\n  color: var(--light-text-primary);\n  border: 1px solid var(--light-border);\n}\n\n.orders-history-container.light-mode .date-input:hover,\n.orders-history-container.light-mode .date-input:focus {\n  border-color: var(--accent-primary);\n  outline: none;\n  background-color: var(--light-bg-secondary);\n}\n\n.orders-history-container.dark-mode .date-input {\n  background-color: var(--dark-bg-primary);\n  color: var(--dark-text-primary);\n  border: 1px solid var(--dark-border);\n}\n\n.orders-history-container.dark-mode .date-input:hover,\n.orders-history-container.dark-mode .date-input:focus {\n  border-color: var(--accent-primary);\n  outline: none;\n  background-color: var(--dark-bg-secondary);\n}\n\n/* Make native date-picker icons visible on dark backgrounds */\n.orders-history-container.dark-mode .date-input::-webkit-calendar-picker-indicator {\n  filter: invert(1) brightness(2) saturate(0.9);\n}\n\n/* Firefox calendar indicator */\n.orders-history-container.dark-mode .date-input::-moz-calendar-picker-indicator {\n  filter: invert(1) brightness(2) saturate(0.9);\n}\n\n/* Fallback: for browsers where indicators don't respond to filter, hide\n   the native icon and provide a white SVG as a background image aligned\n   to the right. This keeps aesthetics consistent. */\n.orders-history-container.dark-mode .date-input {\n  background-repeat: no-repeat;\n  background-position: right 0.6rem center;\n  padding-right: 2.6rem; /* leave room for the icon */\n}\n.orders-history-container.dark-mode .date-input.hide-native-icon::-webkit-calendar-picker-indicator {\n  display: none;\n}\n.orders-history-container.dark-mode .date-input.custom-icon {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%23FFFFFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='4' width='18' height='18' rx='2' ry='2'/%3E%3Cline x1='16' y1='2' x2='16' y2='6'/%3E%3Cline x1='8' y1='2' x2='8' y2='6'/%3E%3Cline x1='3' y1='10' x2='21' y2='10'/%3E%3C/svg%3E\");\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.6rem 0.9rem;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  user-select: none;\n  font-weight: 500;\n  font-size: 1.2rem;\n}\n\n.orders-history-container.light-mode .checkbox-label {\n  background-color: var(--light-bg-primary);\n  border: 1px solid var(--light-border);\n}\n\n.orders-history-container.light-mode .checkbox-label:hover {\n  background-color: var(--accent-primary-soft);\n  border-color: var(--accent-primary);\n}\n\n.orders-history-container.dark-mode .checkbox-label {\n  background-color: var(--dark-bg-primary);\n  border: 1px solid var(--dark-border);\n}\n\n.orders-history-container.dark-mode .checkbox-label:hover {\n  background-color: var(--accent-primary-soft-dark);\n  border-color: var(--accent-primary);\n}\n\n.checkbox-input,\n.card-checkbox {\n  width: 17px;\n  height: 17px;\n  cursor: pointer;\n  accent-color: var(--accent-primary);\n}\n\n/* ==================================\n   PRINT BUTTON\n   ================================== */\n\n.print-button {\n  padding: 0.7rem 1.4rem;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 1.2rem;\n  font-weight: 600;\n  background-color: var(--accent-primary);\n  color: white;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n  align-self: flex-end;\n  max-width: fit-content;\n}\n\n\n.print-button:active:not(:disabled) {\n  transform: translateY(1px);\n}\n\n.print-button.disabled,\n.print-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ==================================\n   EMPTY STATE / NO RESULTS\n   ================================== */\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n  border-radius: var(--radius-lg);\n  margin-top: 2rem;\n}\n\n.orders-history-container.light-mode .empty-state {\n  background-color: var(--light-bg-secondary);\n  border: 1px solid var(--light-border);\n}\n\n.orders-history-container.dark-mode .empty-state {\n  background-color: var(--dark-bg-secondary);\n  border: 1px solid var(--dark-border);\n}\n\n.empty-icon {\n  font-size: 3.5rem;\n  margin-bottom: 1rem;\n  opacity: 0.6;\n}\n\n.empty-order-message {\n  font-size: 1.1rem;\n  margin: 0;\n  font-weight: 500;\n}\n\n.orders-history-container.light-mode .empty-order-message {\n  color: var(--light-text-secondary);\n}\n\n.orders-history-container.dark-mode .empty-order-message {\n  color: var(--dark-text-secondary);\n}\n\n.no-results {\n  text-align: center;\n  padding: 3rem 2rem;\n  font-size: 1rem;\n}\n\n.orders-history-container.light-mode .no-results {\n  color: var(--light-text-secondary);\n}\n\n.orders-history-container.dark-mode .no-results {\n  color: var(--dark-text-secondary);\n}\n\n/* ==================================\n   VIEW SWITCH (table on desktop, cards on mobile)\n   ================================== */\n\n.desktop-view {\n  display: block;\n}\n\n.mobile-view {\n  display: none;\n}\n\n/* ==================================\n   DESKTOP TABLE\n   ================================== */\n\n.orders-table-wrapper {\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.orders-history-container.light-mode .orders-table-wrapper {\n  border: 1px solid var(--light-border);\n  background-color: var(--light-bg-secondary);\n}\n\n.orders-history-container.dark-mode .orders-table-wrapper {\n  border: 1px solid var(--dark-border);\n  background-color: var(--dark-bg-secondary);\n}\n\n.orders-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.92rem;\n}\n\n.orders-table thead th {\n  text-align: right;\n  padding: 0.85rem 1rem;\n  font-weight: 600;\n  font-size: 1.2rem;\n}\n\n.orders-history-container.light-mode .orders-table thead th {\n  color: var(--light-text-secondary);\n  background-color: var(--light-bg-tertiary);\n  border-bottom: 1px solid var(--light-border);\n}\n\n.orders-history-container.dark-mode .orders-table thead th {\n  color: var(--dark-text-secondary);\n  background-color: var(--dark-bg-tertiary);\n  border-bottom: 1px solid var(--dark-border);\n}\n\n.orders-table th.col-check,\n.orders-table td.col-check {\n  width: 64px;\n  text-align: center;\n}\n\n.orders-table td.items-cell {\n  min-width: 260px;\n}\n\n.orders-table tbody tr {\n  transition: background-color var(--transition-fast);\n}\n\n.orders-history-container.light-mode .orders-table tbody tr {\n  border-bottom: 1px solid var(--light-border);\n}\n\n.orders-history-container.dark-mode .orders-table tbody tr {\n  border-bottom: 1px solid var(--dark-border);\n}\n\n.orders-history-container.light-mode .orders-table tbody tr:hover {\n  background-color: var(--light-bg-tertiary);\n}\n\n.orders-history-container.dark-mode .orders-table tbody tr:hover {\n  background-color: var(--dark-bg-tertiary);\n}\n\n.orders-history-container.light-mode .orders-table tbody tr.row-selected {\n  background-color: var(--accent-primary-soft);\n}\n\n.orders-history-container.dark-mode .orders-table tbody tr.row-selected {\n  background-color: var(--accent-primary-soft-dark);\n}\n\n.orders-table td {\n  padding: 0.85rem 1rem;\n  vertical-align: middle;\n}\n\n.order-number-cell {\n  font-weight: 700;\n  color: var(--accent-primary);\n}\n\n/* ==================================\n   SHARED: STATUS BADGE / VALUE HIGHLIGHT\n   ================================== */\n\n.value-highlight {\n  color: var(--accent-success);\n  font-weight: 700;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 0.3rem 0.7rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.status-active {\n  background-color: rgba(5, 150, 105, 0.12);\n  color: var(--accent-success);\n}\n\n.status-pending {\n  background-color: rgba(217, 119, 6, 0.12);\n  color: var(--accent-warning);\n}\n\n.status-completed {\n  background-color: rgba(37, 99, 235, 0.12);\n  color: #2563eb;\n}\n\n.status-cancelled {\n  background-color: rgba(220, 38, 38, 0.12);\n  color: var(--accent-danger);\n}\n\n/* ==================================\n   ITEMS: inline list inside the row (desktop table)\n   and grid (mobile cards) — no expand/collapse needed\n   ================================== */\n\n.items-subtable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.items-subtable tr:not(:last-child) td {\n  border-bottom: 1px dashed transparent;\n}\n\n.orders-history-container.light-mode .items-subtable tr:not(:last-child) td {\n  border-bottom-color: var(--light-border);\n}\n\n.orders-history-container.dark-mode .items-subtable tr:not(:last-child) td {\n  border-bottom-color: var(--dark-border);\n}\n\n.items-subtable td {\n  padding: 0.5rem 0.4rem;\n  vertical-align: middle;\n}\n\n.items-subtable-name {\n  text-align: right;\n}\n\n.items-subtable-qty {\n  width: 50px;\n  text-align: center;\n}\n\n.items-subtable-image {\n  width: 56px;\n  text-align: center;\n}\n\n.item-thumb {\n  width: 44px;\n  height: 44px;\n  object-fit: cover;\n  border-radius: var(--radius-sm);\n  display: inline-block;\n}\n\n.item-thumb-placeholder {\n  background-color: var(--light-bg-tertiary);\n}\n\n.orders-history-container.dark-mode .item-thumb-placeholder {\n  background-color: var(--dark-bg-tertiary);\n}\n\n.order-items-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 0.6rem;\n  margin-top: 0.5rem;\n}\n\n.item-mini {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  padding: 0.6rem;\n  border-radius: var(--radius-md);\n  border-right: 3px solid var(--accent-secondary);\n}\n\n.orders-history-container.light-mode .item-mini {\n  background-color: var(--light-bg-primary);\n}\n\n.orders-history-container.dark-mode .item-mini {\n  background-color: var(--dark-bg-primary);\n}\n\n.item-qty-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 28px;\n  background-color: var(--accent-secondary);\n  color: white;\n  border-radius: 50%;\n  font-size: 0.8rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.item-description {\n  flex-grow: 1;\n  min-width: 0;\n}\n\n.item-name {\n  font-size: 0.88rem;\n  font-weight: 600;\n  word-break: break-word;\n  line-height: 1.4;\n}\n\n.orders-history-container.light-mode .item-name {\n  color: var(--light-text-primary);\n}\n\n.orders-history-container.dark-mode .item-name {\n  color: var(--dark-text-primary);\n}\n\n.item-variant {\n  font-size: 0.78rem;\n  margin-top: 0.2rem;\n  word-break: break-word;\n}\n\n.orders-history-container.light-mode .item-variant {\n  color: var(--light-text-secondary);\n}\n\n.orders-history-container.dark-mode .item-variant {\n  color: var(--dark-text-secondary);\n}\n\n/* ==================================\n   MOBILE CARDS\n   ================================== */\n\n.orders-grid.mobile-view {\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n\n.order-card-modern {\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.2s ease-out;\n}\n\n.orders-history-container.light-mode .order-card-modern {\n  background-color: var(--light-bg-secondary);\n  border: 1px solid var(--light-border);\n}\n\n.orders-history-container.dark-mode .order-card-modern {\n  background-color: var(--dark-bg-secondary);\n  border: 1px solid var(--dark-border);\n}\n\n.order-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.9rem 1rem;\n}\n\n.orders-history-container.light-mode .order-card-header {\n  border-bottom: 1px solid var(--light-border);\n  background-color: var(--light-bg-tertiary);\n}\n\n.orders-history-container.dark-mode .order-card-header {\n  border-bottom: 1px solid var(--dark-border);\n  background-color: var(--dark-bg-tertiary);\n}\n\n.selection-checkbox {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.order-number {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--accent-primary);\n  flex-grow: 1;\n  text-align: center;\n}\n\n.order-card-body {\n  padding: 1.1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.order-info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.3rem 0;\n  font-size: 0.92rem;\n}\n\n.order-info-row .label {\n  font-weight: 600;\n}\n\n.orders-history-container.light-mode .order-info-row .label {\n  color: var(--light-text-secondary);\n}\n\n.orders-history-container.dark-mode .order-info-row .label {\n  color: var(--dark-text-secondary);\n}\n\n.order-info-row .value {\n  font-weight: 500;\n}\n\n.orders-history-container.light-mode .order-info-row .value {\n  color: var(--light-text-primary);\n}\n\n.orders-history-container.dark-mode .order-info-row .value {\n  color: var(--dark-text-primary);\n}\n\n.divider {\n  height: 1px;\n  margin: 0.5rem 0;\n}\n\n.orders-history-container.light-mode .divider {\n  background-color: var(--light-border);\n}\n\n.orders-history-container.dark-mode .divider {\n  background-color: var(--dark-border);\n}\n\n.items-header {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--accent-secondary);\n  padding-bottom: 0.4rem;\n  border-bottom: 2px solid var(--accent-secondary);\n}\n\n@keyframes slideIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* ==================================\n   RESPONSIVE: swap table for cards under 768px\n   ================================== */\n\n@media (max-width: 768px) {\n  .orders-history-container {\n    padding: 1rem 0.75rem;\n  }\n\n  .orders-title {\n    font-size: 1.3rem;\n  }\n\n  .filters-section {\n    padding: 1rem;\n    gap: 0.75rem;\n    grid-template-columns: 1fr;\n  }\n\n  .print-button {\n    align-self: stretch;\n  }\n\n  .desktop-view {\n    display: none;\n  }\n\n  .mobile-view {\n    display: grid;\n  }\n}\n\n@media (max-width: 480px) {\n  .orders-header {\n    flex-direction: column;\n    gap: 0.6rem;\n  }\n\n  .orders-title {\n    width: 100%;\n  }\n}\n\n/* Print media (browser print, kept as a fallback — the real export is the\n   server-generated PDF from the Print button) */\n@media print {\n  .filters-section,\n  .print-button,\n  .orders-header {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
